import {ManagedMethod} from '../types';
import {ManagedMethodOnBackend} from './backendTypes';

export const mapManagedMethodFromBackend = ({
  id,
  name,
  currency,
  provider,
  token_code,
  enabled,
  sort_order,
  country,
}: ManagedMethodOnBackend): ManagedMethod => ({
  id,
  name,
  currency,
  provider,
  tokenCode: token_code,
  enabled,
  sortOrder: sort_order,
  country: country ?? null,
});
